module.exports = __webpack_public_path__ + "media/assets/icon_portfolio-0a579a08a44c49451ddf4c37ecc91ec633239619896ae1cca4a072362832935f.svg";